<template>
    <div>

        <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 -960 960 960">
            <path d="M480-261q57 0 105.5-26t78.5-72q6-12-.5-23T643-393H317q-14 0-20.5 11t-.5 23q30 
            46 78.5 72T480-261ZM347-578l27 27q8 8 18 8t18-8q8-8 8-18t-8-18l-42-42q-9-9-21-9t-21 9l-42 
            42q-8 8-8 18t8 18q8 8 18 8t18-8l27-27Zm267 0 27 27q8 8 18 8t18-8q8-8 
            8-18t-8-18l-42-42q-9-9-21-9t-21 9l-42 42q-8 8-8 18t8 18q8 8 18 8t18-8l27-27ZM480-80q-83 
            0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 
            0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"/>
        </svg>
        
    </div>
</template>

<script>
export default {
    props: ['color', 'size']
}
</script>

<style scoped>

</style>